import Image from "next/image";

const tabList = [
    {
        title: "Summary",
        description: "summary",
        imageBlue: "/mainAssets/assets/images/nav-tab/icon/summery-color.svg",
        imageWhite: "/mainAssets/assets/images/nav-tab/icon/summery-01.svg",
    },
    {
        title: "Table of Content",
        description: "table_of_content",
        imageBlue: "/mainAssets/assets/images/nav-tab/icon/toc-color.svg",
        imageWhite: "/mainAssets/assets/images/nav-tab/icon/toc-01.svg",
    },
    {
        title: "LOT",
        description: "list_of_tables",
        imageBlue: "/mainAssets/assets/images/nav-tab/icon/table-color.svg",
        imageWhite: "/mainAssets/assets/images/nav-tab/icon/table-01.svg",
    },
    {
        title: "Companies",
        description: "key_companies_toc",
        imageBlue: "/mainAssets/assets/images/nav-tab/icon/key-companies-color.svg",
        imageWhite: "/mainAssets/assets/images/nav-tab/icon/key-companies-01.svg",
    },
    {
        title: "Infographics",
        description: "image",
        imageBlue: "/mainAssets/assets/images/nav-tab/icon/infographic-color.svg",
        imageWhite: "/mainAssets/assets/images/nav-tab/icon/infographic-01.svg",
    }
    // Add more tab items as needed
];
export {
    tabList
}